import { render, staticRenderFns } from "./PlantDocumentsData.vue?vue&type=template&id=6e8229dc&"
import script from "./PlantDocumentsData.vue?vue&type=script&lang=ts&"
export * from "./PlantDocumentsData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports